import { parseISO } from 'date-fns'
import _get from 'lodash/get'
import { formatWrapped } from '../../date'
import { exportCSVFile } from '../../file'

export const MAX_PAGE_SIZE = 5000000

const headers = {
  slug: 'Campaign Name',
  id: 'ID',
  language: 'Language',
  isActive: 'Enabled',
  startTs: 'Start Date',
  endTs: 'End Date',
  placement: 'Placement',
  viewMode: 'View Mode',
  createdAt: 'Created At',
  updatedAt: 'Updated At',
  targetMethod: 'Target Method',
  targetParams: 'Target Params',
  weight: 'Weight',
}

const fileTitle = 'Campaigns'

const formatParams = (params) => {
  if (params && Array.isArray(params)) {
    const paramList = params.map((param) => _get(param, 'title'))
    return paramList.join(' | ')
  } return 'none'
}

const formatItems = (dataList) => (
  dataList.map((data) => ({
    slug: _get(data, 'slug'),
    id: _get(data, 'id'),
    language: _get(data, 'language'),
    isActive: _get(data, 'isActive'),
    startTs: formatWrapped(parseISO(_get(data, 'startTs')), 'MM/dd/yyyy'),
    endTs: formatWrapped(parseISO(_get(data, 'endTs')), 'MM/dd/yyyy'),
    placement: _get(data, 'placement'),
    viewMode: _get(data, 'viewMode'),
    createdAt: formatWrapped(parseISO(_get(data, 'createdAt')), 'MM/dd/yyyy'),
    updatedAt: formatWrapped(parseISO(_get(data, 'updatedAt')), 'MM/dd/yyyy'),
    targetMethod: _get(data, 'targetMethod'),
    targetParams: formatParams(_get(data, 'targetParams')),
    weight: _get(data, 'weight'),
  }))
)

export function createCSV (dataMap) {
  const itemsFormatted = formatItems(dataMap)
  exportCSVFile(headers, itemsFormatted, fileTitle)
}
// https://medium.com/@danny.pule/export-json-to-csv-file-using-javascript-a0b7bc5b00d2
